import { Injectable } from "@angular/core";
import { CoreConfigService } from "../../../@core/services/config.service";

@Injectable({
  providedIn: "root",
})
export class LogoService {
  coreConfig: any;
  smallLogoPath = "assets/logo-small.svg";

  constructor(private _coreConfigService: CoreConfigService) {
    this._coreConfigService.config.subscribe((config: any) => {
      this.coreConfig = config;
    });
  }

  get logoPath(): string {
    return `assets/logo-${this.coreConfig.layout.skin === "dark" ? "dark" : "light"}.svg`;
  }
}
